import {
  PlaySolidRegular,
  Text,
  TextWrapper,
  XStack,
  YStack
} from '@ninjacart/nc-nk-ui';
import { useTranslation } from 'react-i18next';

export const VideoViewCount = ({ item }) => {
  const { t } = useTranslation();
  return (
    <YStack position="absolute" zIndex={1} left={15} top={15}>
      <Text
        fontSize={15}
        fontWeight={'600'}
        color={'#000'}
        marginBottom={3}
        numberOfLines={1}
        paddingRight={60}
        paddingTop={5}
      >
        {item?.content?.name.slice(0, 10) + '....'}
      </Text>
      <XStack marginBottom={1}>
        <PlaySolidRegular color={'$primary'} size={25} />
        <TextWrapper
          languaguesToTrim={['ta', 'kn']}
          trimValue={0.9}
          fontSize={12}
          fontWeight={'500'}
          color={'#000'}
          textDecorationLine="underline"
          paddingLeft={3}
          numberOfLines={2}
          position="relative"
          bottom={2}
        >
          {item.content.videoCount}{' '}
          {item.content.videoCount === 1 ? t('page.video') : t('page.videos')}
        </TextWrapper>
      </XStack>
    </YStack>
  );
};
